export default __webpack_public_path__ + "static/persteenolsen-73ddb7be80c47d02cd4d2c60bdff99cf.jpg";